import Vue from 'vue';
import VueI18n from 'vue-i18n';
import lang from '@/lang';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import config from '@/config';
import '@/assets/sass/app.scss';

Vue.use(VueI18n);

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: config.lang,
  messages: lang,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
